<template>
    <main class="training-runner-page">
        <section class="runner-shell">
            <header class="runner-header">
                <div>
                    <p>Training Lab</p>
                    <h1>{{ currentMode.title }}</h1>
                </div>
                <button class="btn btn-secondary" type="button" @click="backToTraining">返回训练模式</button>
            </header>

            <iframe class="training-frame" :src="currentMode.src" :title="currentMode.title"></iframe>
        </section>
    </main>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';

const modeMap = {
    single: {
        title: "普通贪吃蛇",
        src: "/training-static/snake.html",
    },
    ai: {
        title: "单人 AI 训练",
        src: "/training-static/aisnake.html",
    },
    battle: {
        title: "多人 AI 对战",
        src: "/training-static/battlesnake.html",
    },
};

export default {
    setup() {
        const route = useRoute();
        const currentMode = computed(() => modeMap[route.params.mode] || modeMap.single);

        const backToTraining = () => {
            router.push({ name: "training_index" });
        };

        return {
            currentMode,
            backToTraining,
        };
    },
};
</script>

<style scoped>
.training-runner-page {
    width: min(1180px, calc(100% - 32px));
    margin: 0 auto;
    padding: 24px 0 34px;
}

.runner-shell {
    overflow: hidden;
    background: var(--app-surface);
    border: 1px solid var(--app-border);
    border-radius: 18px;
    box-shadow: var(--app-shadow);
}

.runner-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 20px;
    background: var(--app-surface-muted);
    border-bottom: 1px solid var(--app-border);
}

.runner-header p {
    margin: 0 0 4px;
    color: var(--app-primary);
    font-size: 0.78rem;
    font-weight: 900;
}

.runner-header h1 {
    margin: 0;
    color: var(--app-text);
    font-size: 1.45rem;
    font-weight: 900;
}

.training-frame {
    display: block;
    width: 100%;
    height: min(760px, calc(100vh - 180px));
    min-height: 560px;
    background: #ffffff;
    border: 0;
}

@media (max-width: 768px) {
    .training-runner-page {
        width: calc(100% - 16px);
        padding-top: 12px;
    }

    .runner-header {
        align-items: stretch;
        flex-direction: column;
    }

    .training-frame {
        min-height: 520px;
    }
}
</style>
